module.exports = __webpack_public_path__ + "img/cover14.65d75052.png";